'use strict';
(function () {
  if (!customElements.get('marquee-text')) {
    class MarqueeText extends HTMLElement {
      constructor() {
        super();
        this.availableColors = [];
        this.previousColorIndex = -1;
        this.applyRandomColors = this.applyRandomColors.bind(this);
      }

      getDurationSeconds() {
        const speed = this.getAttribute('data-speed') || 'fast';
        const durationMap = {
          slow: '45s',
          normal: '30s',
          fast: '20s',
          'very-fast': '14s',
          'ultra-fast': '10s',
        };
        return durationMap[speed] || '20s';
      }

      connectedCallback() {
        this.loadAvailableColors();
        if (this.availableColors.length > 0) {
          this.addEventListener('mouseenter', this.applyRandomColors, { passive: true });
        }
        this.style.setProperty('--_animation-duration', this.getDurationSeconds());
        this.setAttribute('data-animated', 'true');
      }

      disconnectedCallback() {
        this.removeEventListener('mouseenter', this.applyRandomColors);
      }

      loadAvailableColors() {
        for (let i = 1; i <= 4; i++) {
          const bgColor = this.getAttribute(`data-bg-${i}`);
          const textColor = this.getAttribute(`data-text-${i}`);
          if (bgColor && textColor) {
            this.availableColors.push({ bg: bgColor, text: textColor });
          }
        }
      }

      applyRandomColors() {
        if (!this.availableColors.length || !this.parentElement) return;
        let randomIndex;
        do {
          randomIndex = Math.floor(Math.random() * this.availableColors.length);
        } while (randomIndex === this.previousColorIndex && this.availableColors.length > 1);
        this.previousColorIndex = randomIndex;
        const { bg, text } = this.availableColors[randomIndex];
        this.parentElement.style.setProperty('--color-background-h', bg);
        this.parentElement.style.setProperty('--color-foreground-h', text);
      }
    }

    customElements.define('marquee-text', MarqueeText);
  }
})();
